var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaseGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 188,
    viewBox: "0 0 356 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H340C348.837 0 356 7.16344 356 16V172C356 180.837 348.837 188 340 188H16C7.16344 188 0 180.837 0 172V16Z",
    fill: "#73A2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266 114V50L90 50V114L266 114Z",
    fill: "#00D17F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214 42V146H222V154H134V146H142V42C142 37.5817 145.582 34 150 34H206C210.418 34 214 37.5817 214 42Z",
    fill: "#CED2DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206 106V58H150V106H206Z",
    fill: "#FEFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214 114H142V50H214V114ZM206 61.5713V106H178.033L177.963 82.0122L150 102.443V58H177.966L178.037 82.1126L206 61.5713Z",
    fill: "#0052FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.858 96.1421C167.609 99.8928 172.696 102 178 102C183.304 102 188.391 99.8928 192.142 96.1421C195.893 92.3914 198 87.3043 198 82C198 76.6957 195.893 71.6086 192.142 67.8579C188.391 64.1072 183.304 62 178 62C172.696 62 167.609 64.1072 163.858 67.8579C160.107 71.6086 158 76.6957 158 82C158 87.3043 160.107 92.3914 163.858 96.1421Z",
    fill: "#FFD200"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.848 93.7898C163.708 96.3393 166.146 98.4123 168.961 99.8393C171.776 101.266 174.889 102.007 178.045 102L178.003 82L161.848 93.7898Z",
    fill: "#101114"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M198 82C198 79.3736 197.483 76.7728 196.478 74.3463C195.472 71.9198 193.999 69.715 192.142 67.8579C190.285 66.0007 188.08 64.5275 185.654 63.5224C183.227 62.5173 180.626 62 178 62V82H198Z",
    fill: "#0052FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198 82C198 84.6264 197.483 87.2272 196.478 89.6537C195.472 92.0802 193.999 94.285 192.142 96.1421C190.285 97.9993 188.08 99.4725 185.654 100.478C183.227 101.483 180.626 102 178 102V82H198Z",
    fill: "#00D17F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M194.155 70.2102C192.294 67.6607 189.857 65.5877 187.041 64.1608C184.226 62.7338 181.113 61.9934 177.957 62L177.999 82L194.155 70.2102Z",
    fill: "#101114"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222 147H134V145H222V147Z",
    fill: "#101114"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M231.259 61.5441L225.209 57.1885L224.041 58.8115L230.09 63.1671C231.917 64.4826 233 66.5965 233 68.8479V96H225C224.448 96 224 95.5523 224 95V88H222V95C222 96.6569 223.343 98 225 98H233V126C233 127.657 231.657 129 230 129H214V131H230C232.761 131 235 128.761 235 126V68.8479C235 65.9533 233.608 63.2354 231.259 61.5441Z",
    fill: "#101114"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M224 74C222.895 74 222 74.8954 222 76V88C222 89.1046 222.895 90 224 90H230V96C230 97.1046 230.895 98 232 98H236C237.105 98 238 97.1046 238 96V76C238 74.8954 237.105 74 236 74H224Z",
    fill: "#0052FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M230 76C230 74.8954 230.895 74 232 74H236C237.105 74 238 74.8954 238 76V80C238 81.1046 237.105 82 236 82H232C230.895 82 230 81.1046 230 80V76Z",
    fill: "#0A0B0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseGithub);
export default __webpack_public_path__ + "static/media/BaseGithub.9b9c84e258497da7cf23b1a3d1446c75.svg";
export { ForwardRef as ReactComponent };